/* eslint-disable react/no-unescaped-entities */
import { Checkbox, checkboxStates } from "@visiblethread/react-components";
import clsx from "clsx";
import Flex, { GAP_CLASS } from "components/Flex";
import { ArrowRightIcon } from "lucide-react";
import { array, bool, func, number } from "prop-types";

import classes from "../CombineOutlineDocsModal.module.scss";
import { ReactComponent as ExistingDocuments } from "../ExistingDocuments.svg";
import { ReactComponent as SeparateSectionsIcon } from "../SeparateSectionsIcon.svg";
import { ReactComponent as WorkingDocumentIcon } from "../WorkingDocumentIcon.svg";

const CombinationSummary = ({
  detachDocuments,
  linkedDocumentIds,
  onChangeDetach,
  totalSections,
}) => {
  const hasLinkedDocs = linkedDocumentIds?.length > 0;

  return (
    <>
      <h4>Your outline becomes one document.</h4>
      {hasLinkedDocs ? (
        <p>
          All {totalSections} sections move into a single working document. Any
          content you have written in the sections moves with them. The{" "}
          {linkedDocumentIds.length} existing documents are then replaced.
        </p>
      ) : (
        <p>All {totalSections} sections move into a single working document.</p>
      )}

      <p className={classes.warning}>This can't be undone</p>

      <Flex className={classes.beforeAfter} gap={GAP_CLASS.GAP_150}>
        <div className={classes.box}>
          <strong>Before combining</strong>
          {hasLinkedDocs ? <ExistingDocuments /> : <SeparateSectionsIcon />}

          <h5>
            {hasLinkedDocs
              ? `${linkedDocumentIds.length} Documents`
              : "Separate Sections"}
          </h5>
          <h6>
            <span>{totalSections} sections</span>
            {hasLinkedDocs && (
              <>
                <span>·</span>
                <span>{linkedDocumentIds.length} docs</span>
              </>
            )}
          </h6>
        </div>

        <ArrowRightIcon color="#b4b8bf" size={20} />

        <div className={clsx(classes.box, classes.after)}>
          <strong>After combining</strong>
          <WorkingDocumentIcon />

          <h5>One Working Document</h5>
          <h6>{totalSections} sections</h6>
        </div>
      </Flex>

      {hasLinkedDocs && (
        <Checkbox
          state={
            detachDocuments ? checkboxStates.checked : checkboxStates.empty
          }
          handleChange={onChangeDetach}
          id="detach-documents-checkbox"
          label="Keep the original docs as backup"
        />
      )}
    </>
  );
};

CombinationSummary.propTypes = {
  detachDocuments: bool,
  linkedDocumentIds: array,
  onChangeDetach: func,
  totalSections: number,
};

export default CombinationSummary;
